module.exports = __webpack_public_path__ + "img/hero.c7410191.png";